export type ErrorSeverity = "error" | "warning";

export const DEFAULT_ERROR_SEVERITY: ErrorSeverity = "error";
